<template>
  <BaseNavbar
    navbarClass="is-dark"
    :startItems="startItems"
    :endItems="endItems"
    @action="handleAction"
  >
    <template #end-items>
      <router-link
        key="profile"
        to="/profile"
        class="navbar-item"
        exact-active-class="is-active"
      >
        <div
          v-if="getPlayer"
          class="is-flex is-align-items-center is-justify-content-center"
        >
          <figure class="image is-32x32 mr-1">
            <AvatarImg :player="getPlayer" />
          </figure>
          <span>{{ getPlayer.name }}</span>
        </div>
      </router-link>

      <div class="navbar-item" v-if="getPlayer">
        <StatusSelector />
      </div>
    </template>
  </BaseNavbar>
</template>

<script>
import { mapGetters } from "vuex";
import BaseNavbar from "./BaseNavbar.vue";
import StatusSelector from "@/components/statuses/StatusSelector.vue";
import AvatarImg from "@/components/players/AvatarImg.vue";

export default {
  name: "StudentNavbar",
  components: { BaseNavbar, StatusSelector, AvatarImg },

  computed: {
    ...mapGetters(["getProfile", "getPlayer", "getHasAssignments", "getNewHomeworkCount"]),

    startItems() {
      const items = [
        { label: "Home", to: "/", icon: "fas fa-home" },
        {
          label: "🛝 Lobby",
          icon: "fas fa-chess",
          dropdown: true,
          items: [
            {
              label: "Lobby",
              to: { path: "/lobby" },
              icon: "fas fa-chess",
            },
            {
              label: "Live Matches",
              to: { path: "/live" },
              icon: "fas fa-broadcast-tower",
            },
            {
              label: "Simuls",
              to: { path: "/simuls" },
              icon: "fas fa-th-large",
            },
          ],
        },
        {
          label: "🏁 Tournaments",
          icon: "fas fa-flag-checkered",
          dropdown: true,
          items: [
            {
              label: "Tournaments",
              to: { path: "/tournaments" },
              icon: "fas fa-flag-checkered",
            },
            {
              label: "Hall of Fame",
              to: { path: "/hall-of-fame" },
              icon: "fas fa-trophy",
            },
          ],
        },
        {
          label: "🏆 Leaderboards",
          icon: "fas fa-star",
          dropdown: true,
          items: [
            {
              label: "Leaderboards",
              to: { path: "/leaderboards" },
              icon: "fas fa-star",
            },
            {
              label: "Ratings",
              to: { path: "/ratings" },
              icon: "fab fa-jedi-order",
            },
          ],
        },
        {
          label: "📖 Lessons",
          icon: "fas fa-book-open",
          dropdown: true,
          items: [
            {
              label: "Lessons 🆕",
              to: { path: "/lessons" },
              icon: "fas fa-book-open",
            },
            {
              label: "Live Lessons",
              to: { path: "/live-lessons" },
              icon: "fas fa-book-open",
            },
          ],
        },
      ];

      // Add My Classes menu if user has homework assignments
      if (this.getHasAssignments) {
        const newCount = this.getNewHomeworkCount;
        items.push({
          label: newCount > 0 ? `📚 My Classes (${newCount})` : "📚 My Classes",
          to: { path: "/my-class" },
        });
      }

      return items;
    },

    endItems() {
      if (!this.getPlayer) return [];

      const items = [];

      // Add admin dropdown if user is admin
      if (this.getProfile && this.getProfile.isAdmin) {
        items.push({
          label: "👑 Admin",
          icon: "fas fa-crown",
          class: "has-text-danger",
          dropdown: true,
          items: [
            {
              label: "Tournaments",
              to: { path: "/admin/tournaments" },
              class: "has-text-danger",
            },
            {
              label: "Tickets",
              to: { path: "/admin/tickets" },
              class: "has-text-danger",
            },
            {
              label: "News",
              to: { path: "/admin/news" },
              class: "has-text-danger",
            },
            {
              label: "Notifications",
              to: { path: "/admin/notifications" },
              class: "has-text-danger",
            },
            {
              label: "Permissions",
              to: { path: "/admin/permissions" },
              class: "has-text-danger",
            },
            {
              label: "SAC API Logs",
              to: { path: "/admin/sac-logs" },
              icon: "fas fa-database",
              class: "has-text-danger",
            },
            {
              label: "My Progress",
              to: { path: "/progress" },
              icon: "fas fa-chart-line",
              class: "has-text-info",
            },
            {
              label: "Topics Explorer",
              to: { path: "/topics" },
              icon: "fas fa-sitemap",
              class: "has-text-primary",
            },
            {
              label: "Examples Explorer",
              to: { path: "/examples" },
              icon: "fas fa-chess-board",
              class: "has-text-primary",
            },
            {
              label: "Curriculum",
              to: { path: "/admin/curriculum" },
              icon: "fas fa-book",
              class: "has-text-primary",
            },
            {
              label: "Lectures Planning",
              to: { path: "/lectures" },
              icon: "fas fa-chalkboard",
              class: "has-text-primary",
            },
          ],
        });
      }

      return items;
    },
  },

  methods: {
    handleAction(action) {
      if (action === "logout") {
        this.logout();
      }
    },

    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },
  },
};
</script>
